// src/features/authModal/authModalSlice.js

import { createSlice } from "@reduxjs/toolkit";

const authModalSlice = createSlice({
  name: "authModal",
  initialState: {
    isModalOpen: false,
    authType: "", // 'signIn' or 'signUp'
  },
  reducers: {
    showModal: (state, action) => {
      state.isModalOpen = true;
      state.authType = action.payload;
    },
    hideModal: (state) => {
      state.isModalOpen = false;
      state.authType = "";
    },
  },
});

export const { showModal, hideModal } = authModalSlice.actions;
export default authModalSlice.reducer;
